export const OPPORTUNITY_FUNNEL_PHASES: { steps: string[] }[] = [
  { steps: ['Opportunity'] },
  { steps: ['Booked', 'Issued'] },
  { steps: ['Quoted', 'Sold'] },
  { steps: ['Scheduled', 'Installing'] },
  { steps: ['Completed'] },
];

export const OPPORTUNITY_FUNNEL_STEPS: { label: string }[] = OPPORTUNITY_FUNNEL_PHASES.flatMap(
  (phase) => phase.steps,
).map((label) => ({ label }));
